/* eslint-disable @typescript-eslint/naming-convention */
export interface ColorProps {
    "white.100": string;
    "white.75": string;
    "white.50": string;
    "white.25": string;
    "white.10": string;
    "black.100": string;
    "black.75": string;
    "black.50": string;
    "black.25": string;
    "black.10": string;
    darkGray100: string;
    darkGray75: string;
    darkGray50: string;
    darkGray25: string;
    lightGray100: string;
    lightGray75: string;
    lightGray50: string;
    lightGray25: string;
    disabled: string;
    brand: {
        red: string;
        green: string;
        blue: string;
    };
    blue: {
        strong: string;
        medium: string;
        base: string;
        light: string;
    };
    info: {
        strong: string;
        medium: string;
        base: string;
        light: string;
    };
    warning: {
        strong: string;
        medium: string;
        base: string;
        light: string;
    };
    error: {
        strong: string;
        medium: string;
        base: string;
        light: string;
    };
}

export const colors: ColorProps = {
    "white.100": "rgba(255, 255, 255, 1)", // #FFFFFF
    "white.75": "rgba(255, 255, 255, 0.75)",
    "white.50": "rgba(255, 255, 255, 0.50)",
    "white.25": "rgba(255, 255, 255, .25)",
    "white.10": "rgba(255, 255, 255, 0.10)",
    "black.100": "rgba(0, 0, 0, 1)", // #000000
    "black.75": "rgba(0, 0, 0, 0.75)",
    "black.50": "rgba(0, 0, 0, 0.50)",
    "black.25": "rgba(0, 0, 0, 0.25)",
    "black.10": "rgba(0, 0, 0, 0.10)",
    darkGray100: "rgba(49, 49, 49, 1)", // #313131
    darkGray75: "rgba(49, 49, 49, 0.75)",
    darkGray50: "rgba(49, 49, 49, 0.50)",
    darkGray25: "rgba(49, 49, 49, 0.25)",
    lightGray100: "rgba(89, 89, 89, 1)", // #595959
    lightGray75: "rgba(89, 89, 89, 0.75)",
    lightGray50: "rgba(89, 89, 89, 0.50)",
    lightGray25: "rgba(89, 89, 89, 0.25)",
    disabled: "rgba(255, 255, 255, 0.25)",
    brand: { // delete unwanted colours
        red: "#eb0037",
        green: "#00ff8f",
        blue: "#0032ff"
    },
    blue: {
        strong: "#4065ff",
        medium: "#5979ff",
        base: "#8099ff",
        light: "#bfccff"
    },
    info: {
        strong: "#46e1ff",
        medium: "#74ffff",
        base: "#a3ffff",
        light: "#d1ffff"
    },
    warning: {
        strong: "#ffe63c",
        medium: "#ffec6d",
        base: "#fff59e",
        light: "#fff9ce"
    },
    error: {
        strong: "#ff406e",
        medium: "#ff5980",
        base: "#ff809e",
        light: "#ffbfcf"
    }
};

export type TypographyColors = Pick<ColorProps, "white.100" | "white.75" | "white.50" | "white.25" | "white.10" | "black.100" | "black.75" | "black.50" | "black.25" | "black.10">;
